import { render } from "./AskReportChips.vue?vue&type=template&id=af6086fa&scoped=true"
import script from "./AskReportChips.vue?vue&type=script&lang=js"
export * from "./AskReportChips.vue?vue&type=script&lang=js"

import "./AskReportChips.vue?vue&type=style&index=0&id=af6086fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6086fa"]])

export default __exports__